import { Component, OnInit, EventEmitter, ChangeDetectorRef, inject, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { Account } from "../../entity/Account";
import { LoaderService } from "../../service/loader.service";
import { AccountConsumptionComponent } from "./account-consumption.component";

@Component({
    selector: "i-consumption-dialog",
    templateUrl: "../../../html/incs/i-consumption-dialog.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [AccountConsumptionComponent]
})
export class IConsumptionDialog implements OnInit {
    public updateConsumption = new EventEmitter<boolean>();
    public account: Account;
    public isForm: boolean = false;
    public isAIBased: boolean = false;
    public rewriteEstimationMode: boolean = false;

    cdr = inject(ChangeDetectorRef);

    callUpdate: Subject<boolean> = new Subject();
    callCancel: Subject<boolean> = new Subject();

    constructor(
        public dialogRef: MatDialogRef<IConsumptionDialog>,
        protected loaderService: LoaderService
    ) { 
    }

    ngOnInit(): void {
    }

    ngOnChanges(): void {
    }

    gotoAccountConsumption(): void {
        this.isForm = true;
        this.cdr.detectChanges();
    }

    onSetEstimated(): void {         // New method to handle setEstimated event
        this.rewriteEstimationMode = true;
        this.cdr.detectChanges();   // Manually trigger change detection
    }

    editCancel(): void {
        this.closeDialog();
    }

    updateAccountConsumption(): void {
        this.callUpdate.next(true);
        // No view change needed, but if child component updates any parent-bound data, 
        // consider calling detectChanges() here as well.
    }

    updateAccountConsumptionFinish(): void {
        this.updateConsumption.emit(this.rewriteEstimationMode);
        this.closeDialog();
    }

    closeDialog() {
        this.dialogRef.close(null!);
    }
}